import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=4a33df40&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=4a33df40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33df40",
  null
  
)

export default component.exports